import { render, staticRenderFns } from "./scorelog.vue?vue&type=template&id=d920300e&scoped=true&"
import script from "./scorelog.vue?vue&type=script&lang=js&"
export * from "./scorelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d920300e",
  null
  
)

export default component.exports